import React from "react";
import BaseModal, { BaseModalProps } from "./BaseModal";
import styled from "styled-components";

type ActionModalProps = Omit<BaseModalProps, "children"> & {
  onCancel?: () => void;
  onEdit?: () => void;
  cancelText?: string;
  editText?: string;
};

const ActionModal: React.FC<ActionModalProps> = ({

  onClose,
  onCancel,
  onEdit,
  cancelText = "",
  editText = "",
  ...rest
}) => {


  return (
    <BaseModal {...rest}  onClose={onClose}>
      <ButtonContainer>
        <CancelButton
          onClick={() => {
            onCancel?.();
            onClose();
          }}
        >
          {cancelText}
        </CancelButton>
        <EditButton
          onClick={() => {
            onEdit?.();
            onClose();
          }}
        >
          {editText}
        </EditButton>
      </ButtonContainer>
    </BaseModal>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 16px;
`;

const CancelButton = styled.button`
border: 1px solid #79818A;
  flex: 1;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #79818A;
  color: #FDFDFD;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
   border-radius: 0 0 0rem 1rem;
`;

const EditButton = styled.button`
  flex: 1;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #004b49;
  color: white;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
 border-radius: 0 0 1rem 0rem;
`;

export default ActionModal;

